import { createFeature, createReducer, on } from '@ngrx/store';
import { AttributeType, MetaData } from '@emi/shared/models';
import * as attributeTypeActions from './attribute-type-actions';
import * as commonActions from '../common-actions';

export interface AttributeTypeState {
    attributeTypes: AttributeType[];
    metadata: MetaData | null;
    searchText: string | null;
    loading: boolean;
    failed: boolean;
    error: string;
}

export const attributeTypeFeatureKey = 'attributeTypeFilters';

const initialState: AttributeTypeState = {
    attributeTypes: [],
    metadata: null,
    searchText: null,
    loading: false,
    failed: false,
    error: '',
};

export const attributeTypeFeature = createFeature({
    name: attributeTypeFeatureKey,
    reducer: createReducer(
        initialState,
        on(attributeTypeActions.isLoadingAttributeTypes, (state) => {
            return {
                ...state,
                loading: true,
            };
        }),
        on(attributeTypeActions.getNextPageAttributeTypes, (state) => {
            return {
                ...state,
                loading: true,
            };
        }),
        on(attributeTypeActions.getAttributeTypesSuccess, (state, { attributeTypes, metadata, searchText }) => {
            return {
                ...state,
                attributeTypes,
                metadata,
                searchText,
                loading: false,
                failed: false,
                error: '',
            };
        }),
        on(attributeTypeActions.updateAttributeTypesSelectionSuccess, (state, { attributeTypes, metadata }) => {
            return {
                ...state,
                attributeTypes: [...state.attributeTypes, ...attributeTypes],
                metadata,
                loading: false,
                failed: false,
                error: '',
            };
        }),
        on(attributeTypeActions.getAttributeTypesFailure, (state, { error }) => {
            return {
                ...state,
                loading: false,
                failed: true,
                error: error.message,
            };
        }),
        on(attributeTypeActions.searchAttributeTypes, (state, { searchText }) => {
            return {
                ...state,
                loading: state.searchText !== searchText,
            };
        }),
        on(commonActions.clearFilters, () => {
            return initialState;
        })
    ),
});
